// src/shared/vies.js — VIES проверка на ДДС номер (копие от app.js, Фаза 3).
// Чисти функции: legacy копията остават в app.js за немигрираните екрани.

import { el } from './dom.js';
import { toast } from './toast.js';
import { api } from './api.js';

export function viesParse(raw) {
  const s = String(raw || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  if (!s) return null;
  if (/^[A-Z]{2}/.test(s)) return { countryCode: s.slice(0, 2), vatNumber: s.slice(2) };
  return { countryCode: 'BG', vatNumber: s };
}

export function viesButton(getVat, onValid) {
  const btn = el('button', { type: 'button', class: 'btn sm ghost', text: 'Провери в VIES', onClick: async () => {
    const pp = viesParse(getVat());
    if (!pp || !pp.vatNumber) { toast('Въведете ДДС номер.', true); return; }
    const orig = btn.textContent; btn.disabled = true; btn.textContent = 'Проверявам…';
    try {
      const r = await api('/vies/check', { method: 'POST', body: JSON.stringify(pp) });
      if (r.valid) { toast('Валиден по VIES ✓' + (r.name ? ' — ' + r.name : '')); if (onValid) onValid(r); }
      else toast('Невалиден ДДС номер по VIES ✗', true);
    } catch (e) { toast((e && e.message) || 'VIES грешка', true); }
    finally { btn.disabled = false; btn.textContent = orig; }
  } });
  return btn;
}
